import React, { Component } from 'react';
import {
  FormGroup,
  Input,
  Label,
  FormFeedback,
  Row,
  Col,
  Button,
} from 'reactstrap';
import client from '../../../client';
import config from '../../../config';
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google"
import axios from 'axios';

class GoogleLoginComp extends Component {
  constructor(props) {
    super(props);
  }
  responseGoogle = response => {
    let token = response.access_token;
    if (token) {
      axios
        .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${token}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
          }
        })
        .then((res) => {
          const d = res && res.data;
          const payload = {
            requiredRole: this.props.requiredRole,
            user : {
              email: d && d.email,
              givenName: d && d.given_name,
              familyName: d && d.family_name,
              photoUrl: d && d.picture,
              id: d && d.id
            }
          }
          client()
            .post(`${config.publicAPI}/googleLogin`, payload)
            .then(res => {
              const { authenticationCallback } = this.props;
              authenticationCallback();
            })
            .catch(error => { });
        })
        .catch((err) => console.log(err));
    }
  };

  render() {
    const { clientId, label } = this.props;
    return (
      <GoogleOAuthProvider clientId={
        clientId
          ? clientId
          : '996886828755-qq0pfj5307tat8ftd2c5sdc7d047atts.apps.googleusercontent.com'
      }>
        <GoogleButton label={label} responseGoogle={this.responseGoogle} />
      </GoogleOAuthProvider>
    );
  }
}

const GoogleButton = (props) => {
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => props.responseGoogle(codeResponse),
    onError: (error) => console.log('Login Failed:', error)
  });
  return <div>
    <Button onClick={() => login()}>
      <i className='fa fa-google-plus'></i> {props.label ? props.label : "LOGIN WITH GOOGLE"}
    </Button>
  </div>
}

export default GoogleLoginComp;
